import React from 'react';
import { useSelector } from 'react-redux';

import Translation from '@swf/components/Translation/Translation';
import { select } from '@swf/core/store';

import { deleteClubEmail, deleteClubInstructions, row } from '../Settings.scss';

import {
  TXTWCL_Delete_Club,
  TXTWCL_To_delete_the_clubX_please_con_ELL
} from './DeleteClub.messages.json';

const DeleteClub: React.FC = () => (
  <div className={row}>
    <h2>
      <Translation {...TXTWCL_Delete_Club} />
    </h2>
    <p className={deleteClubInstructions}>
      <Translation
        {...TXTWCL_To_delete_the_clubX_please_con_ELL}
        values={{
          email: (
            <span className={deleteClubEmail}>
              support@{useSelector(select.site.getStarsDomain)}
            </span>
          )
        }}
      />
    </p>
  </div>
);

export default DeleteClub;
